import firebaseAuthService from '../repositories/firebase/firebaseAuth';
import useAuthStore from '../store/authStore';
import {Result} from '../models/result';
// Pure functions for better testing
export const getCurrentToken = (store) => {
  const { userToken } = store.getState();
  return userToken;
};

export const refreshToken = async (store) => {
  const user = firebaseAuthService.getCurrentUser();
  if (!user) {
    return new Result({ message: 'No authenticated user found', code: 'AUTH_ERROR' });
  }
  
  const freshToken = await user.getIdToken(true);
  store.setState({ userToken: freshToken });
  console.log(`freshtoken set`)
  return new Result({ value: freshToken });
};

// Convenience wrapper for production use

export const authUtils = {
  getCurrentToken: () => getCurrentToken(useAuthStore),
  refreshToken: () => refreshToken(useAuthStore)
};
